module.exports = __webpack_public_path__ + "static/img/approve.32c4785b.png";